// Concierge (valet, `v`) tracking pages now live on the guest site. Old texts
// still point here, so a `v` link is sent on to the same path on guest.
// Appointment (`a`) links stay on this site.

export const GUEST_ORIGINS = {
  production: 'https://guest.hopdrive.io',
  test: 'https://guest-test.hopdrive.io',
};

// REACT_APP_ENV is set per Netlify site, like the GraphQL URLs. Anything other
// than production (test, development, unset) goes to guest-test.
export function getGuestOrigin(env) {
  return env === 'production' ? GUEST_ORIGINS.production : GUEST_ORIGINS.test;
}

// Modern (v2+) magic-link hashes carry their type letter as the first
// character, followed by a base64url body. That's what @hopdrive/sdk-auth's
// peekMagicLinkType reads without a key (see packages/auth/src/features/
// magic-links/v2/prefix.ts in hopdrive/sdk). Legacy v1 hashes are hex
// `iv:cipher` and can't start with `v`, so they never match. That's on
// purpose: guest refuses v1 concierge links, so those stay on this site.
const MODERN_CONCIERGE_HASH = /^v[A-Za-z0-9_-]+$/;

export function isConciergeHash(hash) {
  return typeof hash === 'string' && MODERN_CONCIERGE_HASH.test(hash);
}

// Same path, query string and fragment, on the guest host.
export function buildGuestUrl(location, env) {
  return `${getGuestOrigin(env)}${location.pathname}${location.search || ''}${location.hash || ''}`;
}

export function forwardToGuest(location, env) {
  location.replace(buildGuestUrl(location, env));
}
